(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-product"] && !Shopify.designMode) return;
  try {
    
class ProductFormAL extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('.al-variants-json').textContent);
    this.selects = Array.from(this.querySelectorAll('.al-options__select'));
    this.idInput = this.querySelector('.al-variant-id');
    this.btn = this.querySelector('.al-atc');
    this.section = this.closest('.al-product');
    this.priceWrap = this.section.querySelector('.al-price');
    this.selects.forEach(function(s){ s.addEventListener('change', this.onChange.bind(this)); }, this);
    var thumbs = this.section.querySelectorAll('.al-product__thumb');
    var mainImg = this.section.querySelector('.al-product__media img');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        if (mainImg) { mainImg.src = t.dataset.full; }
        thumbs.forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
    var modal = this.section.querySelector('.al-sgmodal');
    var opener = this.section.querySelector('.al-sizeguide');
    if (modal && opener) {
      opener.addEventListener('click', function(){ modal.hidden = false; document.body.style.overflow = 'hidden'; });
      modal.querySelectorAll('[data-sg-close]').forEach(function(el){
        el.addEventListener('click', function(){ modal.hidden = true; document.body.style.overflow = ''; });
      });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) { modal.hidden = true; document.body.style.overflow = ''; } });
    }
  }
  onChange() {
    var chosen = this.selects.map(function(s){ return s.value; });
    var match = this.variants.find(function(v){
      return chosen.every(function(val, i){ return v.options[i] === val; });
    });
    if (!match) {
      this.btn.disabled = true;
      this.btn.querySelector('.al-atc__label').textContent = 'Unavailable';
      return;
    }
    this.idInput.value = match.id;
    this.btn.disabled = !match.available;
    this.btn.querySelector('.al-atc__label').textContent = match.available ? this.btn.dataset.label || 'Add to cart' : 'Sold out';
    var now = this.priceWrap.querySelector('.al-price__now');
    if (now) { now.textContent = this.formatMoney(match.price); }
    var was = this.priceWrap.querySelector('.al-price__was');
    if (was && match.compare_at_price > match.price) { was.textContent = this.formatMoney(match.compare_at_price); }
    if (match.featured_media && match.featured_media.preview_image) {
      var mainImg = this.section.querySelector('.al-product__media img');
      if (mainImg) { mainImg.src = match.featured_media.preview_image.src; }
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  }
  formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return window.Shopify && Shopify.currency && Shopify.currency.active === 'EUR' ? '€' + amount : '$' + amount;
  }
}
customElements.define('product-form-al', ProductFormAL);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glossi-presell-lp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    /* Gallery with dots and thumbs */
    var thumbs = document.querySelectorAll('.glp-thumb');
    var slides = document.querySelectorAll('.glp-hero-gallery__slide');
    var dots = document.querySelectorAll('.glp-dot');

    function goToSlide(idx) {
      slides.forEach(function(s) { s.classList.remove('active'); });
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      dots.forEach(function(d) { d.classList.remove('active'); });
      if (slides[idx]) slides[idx].classList.add('active');
      if (thumbs[idx]) thumbs[idx].classList.add('active');
      if (dots[idx]) dots[idx].classList.add('active');
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.thumb));
      });
    });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.dot));
      });
    });

    /* Auto-advance gallery */
    var currentSlide = 0;
    setInterval(function() {
      currentSlide = (currentSlide + 1) % slides.length;
      goToSlide(currentSlide);
    }, 4000);

    /* Touch swipe for gallery */
    var gallery = document.querySelector('.glp-hero-gallery__main');
    var startX = 0;
    if (gallery) {
      gallery.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; });
      gallery.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) { currentSlide = (currentSlide + 1) % slides.length; }
          else { currentSlide = (currentSlide - 1 + slides.length) % slides.length; }
          goToSlide(currentSlide);
        }
      });
    }

    /* Countdown Timer */
    var totalSeconds = 2 * 3600;
    var saved = sessionStorage.getItem('glp_timer');
    if (saved) { totalSeconds = parseInt(saved); }
    function updateTimer() {
      if (totalSeconds <= 0) { totalSeconds = 2 * 3600; }
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;
      var hEl = document.getElementById('glp-hrs');
      var mEl = document.getElementById('glp-min');
      var sEl = document.getElementById('glp-sec');
      if (hEl) hEl.textContent = h.toString().padStart(2, '0');
      if (mEl) mEl.textContent = m.toString().padStart(2, '0');
      if (sEl) sEl.textContent = s.toString().padStart(2, '0');
      totalSeconds--;
      sessionStorage.setItem('glp_timer', totalSeconds);
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glp-announcement"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var totalSeconds = 2 * 3600;
    var saved = sessionStorage.getItem('glp_timer');
    if (saved) { totalSeconds = parseInt(saved); }
    function updateTimer() {
      if (totalSeconds <= 0) { totalSeconds = 2 * 3600; }
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;
      var hEl = document.getElementById('glp-hrs');
      var mEl = document.getElementById('glp-min');
      var sEl = document.getElementById('glp-sec');
      if (hEl) hEl.textContent = h.toString().padStart(2, '0');
      if (mEl) mEl.textContent = m.toString().padStart(2, '0');
      if (sEl) sEl.textContent = s.toString().padStart(2, '0');
      totalSeconds--;
      sessionStorage.setItem('glp_timer', totalSeconds);
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glp-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var thumbs = document.querySelectorAll('.glp-thumb');
    var slides = document.querySelectorAll('.glp-hero-gallery__slide');
    var dots = document.querySelectorAll('.glp-dot');
    function goToSlide(idx) {
      slides.forEach(function(s) { s.classList.remove('active'); });
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      dots.forEach(function(d) { d.classList.remove('active'); });
      if (slides[idx]) slides[idx].classList.add('active');
      if (thumbs[idx]) thumbs[idx].classList.add('active');
      if (dots[idx]) dots[idx].classList.add('active');
    }
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() { goToSlide(parseInt(this.dataset.thumb)); });
    });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.dot)); });
    });
    var currentSlide = 0;
    setInterval(function() { currentSlide = (currentSlide + 1) % slides.length; goToSlide(currentSlide); }, 4000);
    var gallery = document.querySelector('.glp-hero-gallery__main');
    var startX = 0;
    if (gallery) {
      gallery.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; });
      gallery.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) { currentSlide = (currentSlide + 1) % slides.length; }
          else { currentSlide = (currentSlide - 1 + slides.length) % slides.length; }
          goToSlide(currentSlide);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glp-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    /* Slider nav buttons */
    document.querySelectorAll('.glp-ugc-video__nav-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var slider = document.getElementById(this.dataset.slider);
        if (!slider) return;
        var scrollAmount = slider.offsetWidth * 0.8;
        if (this.dataset.dir === 'left') { slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' }); }
        else { slider.scrollBy({ left: scrollAmount, behavior: 'smooth' }); }
      });
    });
    /* Click to play video */
    document.querySelectorAll('.glp-ugc-video__placeholder').forEach(function(ph) {
      ph.addEventListener('click', function() {
        var url = this.dataset.videoUrl;
        if (!url) return;
        var player = this.closest('.glp-ugc-video__player');
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
          var vid = url.match(/(?:v=|youtu\.be\/)([^&?]+)/);
          if (vid) { player.innerHTML = '<iframe src="https://www.youtube.com/embed/' + vid[1] + '?autoplay=1" frameborder="0" allow="autoplay" allowfullscreen style="width:100%;aspect-ratio:9/16;display:block;"></iframe>'; }
        } else if (url.includes('vimeo.com')) {
          var vid = url.match(/vimeo\.com\/(\d+)/);
          if (vid) { player.innerHTML = '<iframe src="https://player.vimeo.com/video/' + vid[1] + '?autoplay=1" frameborder="0" allow="autoplay" allowfullscreen style="width:100%;aspect-ratio:9/16;display:block;"></iframe>'; }
        } else {
          player.innerHTML = '<video src="' + url + '" autoplay playsinline controls style="width:100%;display:block;"></video>';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
